import superAGIEmptyDarkIcon from "@/src/assets/images/dark/platform/superagi_empty_icon.svg";
import superAGIEmptyLightIcon from "@/src/assets/images/light/platform/superagi_empty_icon.svg";
import superAGIBoltFilledIcon from "@/src/assets/images/neutral/platform/superagi_bolt_filled_icon.svg";
import superAGIBoltHollowIcon from "@/src/assets/images/neutral/platform/superagi_bolt_hollow_icon.svg";

export default {
  dark: {
    empty: {
      superAGIBolt: superAGIEmptyDarkIcon,
    },
  },

  light: {
    empty: {
      superAGIBolt: superAGIEmptyLightIcon,
    },
  },

  neutral: {
    single: {
      superAGIFilledBolt: superAGIBoltFilledIcon,
      superAGIHollowBolt: superAGIBoltHollowIcon,
    },
  },
};
